/**
 * Gateway prefix for campaign-service, which owns discount campaigns, the
 * office↔campaign link ("applied codes") and the redemption lifecycle.
 *
 * The portal has a single axios instance pointed at the gateway
 * (`VITE_BASE_URL`), and the ingress rewrites the service prefix to `/`.
 * Office-facing routes address the caller from the JWT — no office id in the
 * path or body (the IDOR rule) — and `getAuthHeaders()` already sends
 * `x-office`, which is what lets a DSO parent act on a child.
 *
 * VERIFIED against dev on 2026-08-31, after campaign-service#74 merged and
 * deployed: `GET {VITE_BASE_URL}/campaign-service/v1/offices/applied-codes`
 * answers 401 (route present, auth required), while `/campaign-service-api/...`
 * answers 404. Controls for that probe: the known-good
 * `/awards-service-api/cycles` answers 401 and a nonsense path answers 404, so a
 * 404 here means no route rather than a rejected request.
 *
 * Note the asymmetry with `AWARDS_API_PREFIX` (`/awards-service-api`): the
 * `-api` suffix is not a convention to copy. Most services route at
 * `/<name>-service` (`/auth-service`, `/posting-service`, `/recruitment-service`
 * all do, despite `-api` suffixed deploy directories in `cicd-workstate`), and
 * campaign-service is one of them. Probe, don't infer, when adding the next one.
 */
export const CAMPAIGN_API_PREFIX = '/campaign-service';

/** Office-facing applied-codes collection: GET lists the history, POST applies a new code. */
export const DISCOUNT_CODES_PATH = `${CAMPAIGN_API_PREFIX}/v1/offices/applied-codes`;
